import { Button, makeStyles } from "@fluentui/react-components";
import { useState } from "react";
import { Translation } from "react-i18next";
import { DocumentGridViewItem } from "../../models/DocumentGridViewItem";
import { VsaaColorTokens } from "../../style/VsaaColorTokens";
import ToolActivitiesDialog from "./ToolActivitiesDialog";

const useActivitiesCellStyles = makeStyles({
  seeActivitiesButton: {
    border: "none",
    padding: 0,
    minWidth: "auto",
    background: "none",
    textAlign: "left",
    width: "100%",
    display: "flex",
    justifyContent: "start",
    color: VsaaColorTokens.color_hyperlink,
    fontWeight: "400",
  },
});

interface DocumentGridActivitiesCellProps {
  item: DocumentGridViewItem;
}

const DocumentGridActivitiesCell = ({
  item,
}: DocumentGridActivitiesCellProps) => {
  const classes = useActivitiesCellStyles();
  const [open, setOpen] = useState(false);
  const count = item.activities?.length ?? 0;

  return (
    <>
      <Translation>
        {(t) => (
          <Button
            className={classes.seeActivitiesButton}
            onClick={() => setOpen(true)}
          >
            {count === 0
              ? "-"
              : `${count === 1 ? t("showActivity") : t("showActivities")} (${count})`}
          </Button>
        )}
      </Translation>
      <ToolActivitiesDialog
        open={open}
        onClose={() => setOpen(false)}
        activities={item.activities ?? []}
        toolTitle={item.title}
      />
    </>
  );
};

export default DocumentGridActivitiesCell;
